<template>
  <div class="tabs">
    <ul class="tabs__tab md:inline-flex">
      <li
        class="w-full md:w-auto"
        :class="{ 'current': activeTab === 'membershipInformation', 'disabled': activeTab !== 'membershipInformation' }"
      >
        <a
          id="tab-membershipInformation"
          href="#"
          :aria-selected="activeTab === 'membershipInformation'"
          v-text="'1. Member Information'"
        />
      </li>
      <li
        class="w-full md:w-auto"
        :class="{ 'current': activeTab === 'groups', 'disabled': activeTab !== 'groups' }"
      >
        <a
          id="tab-groups"
          href="#"
          :aria-selected="activeTab === 'groups'"
          v-text="'2. Add to Groups'"
        />
      </li>
      <li
        class="w-full md:w-auto"
        :class="{ 'current': activeTab === 'membershipPermissions', 'disabled': activeTab !== 'membershipPermissions' }"
      >
        <a
          id="tab-membershipPermissions"
          href="#"
          :aria-selected="activeTab === 'membershipPermissions'"
          v-text="'3. Add User Permissions'"
        />
      </li>
      <li
        v-if="paymentsEnabled"
        class="w-full md:w-auto"
        :class="{ 'current': activeTab === 'membershipFee', 'disabled': activeTab !== 'membershipFee' }"
      >
        <a
          id="tab-membershipFee"
          href="#"
          :aria-selected="activeTab === 'membershipFee'"
          v-text="'4. Configure Membership Fee'"
        />
      </li>
    </ul>
    <div class="tabs__tab_content">
      <div
        v-show="activeTab === 'membershipInformation'"
        :aria-hidden="activeTab === 'membershipInformation'"
        aria-labelledby="tab-membershipInformation"
      >
        <MembershipForm
          admin-mode
          @setMembershipUuid="setMembershipUuid"
        />
      </div>
      <div
        v-show="activeTab === 'groups'"
        :aria-hidden="activeTab === 'groups'"
        aria-labelledby="tab-groups"
      >
        <MembershipGroupsAssigner
          :membership-uuid="membershipUuid"
          @membershipGroupsHaveBeenAssigned="membershipGroupsHaveBeenAssigned"
        />
      </div>
      <div
        v-show="activeTab === 'membershipPermissions'"
        :aria-hidden="activeTab === 'membershipPermissions'"
        aria-labelledby="tab-membershipPermissions"
      >
        <MembershipAbilities
          context="creation"
          :membership-uuid="membershipUuid"
          @membershipAbilitiesHaveBeenAssigned="membershipAbilitiesHaveBeenAssigned"
        />
      </div>
      <div
        v-show="activeTab === 'membershipFee'"
        :aria-hidden="activeTab === 'membershipFee'"
        aria-labelledby="tab-membershipFee"
      >
        <ConfigureMembershipFee
          context="creation"
          :membership-uuid="membershipUuid"
          @membershipFeeHasBeenConfigured="membershipFeeHasBeenConfigured"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import MembershipGroupsAssigner from 'Membership/Resources/assets/js/components/MembershipGroupAssigner'
import MembershipAbilities from 'Membership/Resources/assets/js/components/MembershipAbilities'
import ConfigureMembershipFee from 'Membership/Resources/assets/js/components/ConfigureMembershipFee'
import MembershipForm from 'Membership/Resources/assets/js/components/profiles/MembershipForm'

export default {
  name: 'MembershipCreator',
  components: {
    MembershipForm,
    MembershipGroupsAssigner,
    MembershipAbilities,
    ConfigureMembershipFee,
  },
  data() {
    return {
      activeTab: 'membershipInformation',
      membershipUuid: null,
    }
  },
  computed: {
    paymentsEnabled() {
      return this.$root.Union.payments_enabled
    },
  },
  methods: {
    changeActiveTab(tab) {
      this.activeTab = tab

      history.pushState(null, null, '#' + tab)
      window.scrollTo(0, 0)
    },
    setMembershipUuid(membershipUuid) {
      this.membershipUuid = membershipUuid

      this.changeActiveTab('groups')
    },
    membershipGroupsHaveBeenAssigned() {
      this.changeActiveTab('membershipPermissions')
    },
    membershipAbilitiesHaveBeenAssigned() {
      this.paymentsEnabled ? this.changeActiveTab('membershipFee') : this.redirect()
    },
    membershipFeeHasBeenConfigured() {
      this.redirect()
    },
    redirect() {
      window.location = this.$urlGenerator.active('members/' + this.membershipUuid + encodeURI('?status=Membership abilities updated!&showInviteModal=true'))
    },
  },
}
</script>
